import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=71ef0aa3&scoped=true"
import script from "./Stories.vue?vue&type=script&lang=ts"
export * from "./Stories.vue?vue&type=script&lang=ts"
import style0 from "./Stories.vue?vue&type=style&index=0&id=71ef0aa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef0aa3",
  null
  
)

export default component.exports